import { useEffectOnce } from '../../shared/hooks'
import { config } from '../../shared/config'
import LoadingScreen from '../../components/LoadingScreen'

function SignUp () {
  useEffectOnce(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const courseUid = urlParams.get('course')

    if (courseUid) {
      localStorage.setItem('pendingCourseUid', courseUid)
    }

    window.location.replace(`${config.API_HOST}/auth/login`)
  })

  return <LoadingScreen />
}

export default SignUp
